import { css } from "@emotion/react";

import { colors, dimensions } from "@styles";

export const mainLink = css`
  text-decoration: none;
  &:hover {
    span {
      color: ${colors.green.base}!important;
    }
  }
`;

export const button = css`
  border-radius: 0.5rem;
  &:hover {
    box-shadow: 0 4px 4px rgb(0, 0, 0, 25%) !important;
  }
`;

export const softwareBlurb = css`
  margin-left: 1.5rem;
  @media only screen and (max-width: ${dimensions.tabletMax}) {
    margin-left: 0;
  }
`;

export const mobileContent = css`
  border-bottom: 1px solid #e4e9ed;
  padding-bottom: 2rem;
`;

export const mobileButton = css`
  width: 100%;
`;
